import type { SVGProps } from 'react';
import ZepIcon from '../ZepIcon';
export const ResetIcon = ZepIcon((props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <g clipPath="url(#Reset_svg__a)">
      <path fill={props.fill || `currentColor`} d="M7.391 2.74a1 1 0 0 0-1.225.707L5.068 7.545a1 1 0 0 0 .707 1.225l4.098 1.098a1 1 0 0 0 .518-1.932l-1.766-.473 1.373-.793c3.073-1.774 7.106-.693 8.88 2.38 1.773 3.071.693 7.104-2.38 8.878s-7.105.694-8.879-2.379a1 1 0 0 0-1.732 1c2.326 4.03 7.582 5.438 11.611 3.111s5.438-7.582 3.111-11.61C18.283 4.02 13.027 2.611 9 4.937l-1.374.793.473-1.766a1 1 0 0 0-.707-1.225" />
    </g>
    <defs>
      <clipPath id="Reset_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>);